import axios from "axios";
import * as ActionTypes from "./actionTypes";
import * as urls from "../common/urls";


export function getPage(pageId) {
    const url = `${urls.PAGES_URL}${pageId}`;
    const request = axios.get(url);
    return { type: ActionTypes.GET_PAGE, payload: request };

}
